<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-5 col-sm-5 col-12 text-left mt-4">
          <h6>PRODUCT</h6>
          <!--<router-link class="d-block text-secondary" to="/howitworks">
            How It Works
          </router-link>
          <router-link class="d-block text-secondary" to="/pricing">
            Pricing
          </router-link>
          <router-link class="d-block text-secondary" to="/signin">
            Sign In
          </router-link>
          <router-link class="d-block text-secondary" to="/tryforfree">
            Try Free
          </router-link>-->
        </div>
        <div class="col-md-4 col-sm-4 col-lg-5 col-12 mt-4 text-left ">
          <h6>LEARN MORE</h6>
          <!--<router-link class="d-block text-secondary" to="/aboutus">
            About Us
          </router-link>
          <router-link class="d-block text-secondary" to="/contactus">
            Contact Us
          </router-link>-->
          <router-link class="d-block text-secondary" to="/tutorials">
            Tutorials
          </router-link>
          <router-link class="d-block text-secondary" to="/privacypolicy">
            Privacy Policy
          </router-link>
        </div>
        <div class="col-md-3 col-sm-3 col-lg-2 col-xs-12 mt-4 text-left ">
          <h6>Special Data</h6>
          <p class="mb-0">‭(385) 368-0355</p>
          <a href="mailto:support@myspecialdata.com‬" class="mb-0"
            >‭sara.jensen@mtnstech.com‬</a
          >
        </div>
      </div>
    </div>
    <!--<div
      class="mt-2 ml-4 mr-4"
      style="height: 1px; background-color:gray;"
    ></div>-->
    <div>
      <p class="py-2 mb-0">
        &copy; {{ new Date().getFullYear() }} Special Data
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Template",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    method() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  background-color: #dddddd;
}

.logo {
  width: 4rem;
  height: 4rem;
}
</style>
